export default "__VITE_ASSET__Dq0V0bg6__"